<template>
    <div class="hotel-product" @click="toggle">
        <div class="img-box" v-if="hotelObj.chinese_name">
            <img
                v-lazy="hotelObj.picture"
                alt="imgs"
            />
        </div>
        <div class="content" v-if="hotelObj.chinese_name">
            <h3 class="text-overflow-line2">
                {{hotelObj.chinese_name}}&nbsp;<span>{{hotelObj.star_name}}</span>
            </h3>
            <div class="nums">
                <span>{{hotelObj.ratings&&Number(hotelObj.ratings).toFixed(1)}}</span>
                <span v-if="hotelObj.page_view>=100">{{hotelObj.page_view}}</span>
                <span v-if="hotelObj.page_view>=100">浏览量</span>
            </div>
            <p>距您{{unitConvert(hotelObj.distance)}}<span v-if="hotelObj.business_district"> · {{hotelObj.business_district}}</span></p>
            <div class="tags" v-if="hotelObj.label">
                <span 
                    class="tag-cg"
                    v-for="(item,index) of showTag(hotelObj.label)"
                    :key="index"
                    :class="`tag${(index+1)%5}`"
                >{{item}}</span>
            </div>
            <div class="price">
                <div>
                    <span>¥</span>
                    <!-- <span>{{hotelObj.hotel && hotelObj.hotel.price}}</span> -->
                    <span>{{hotelObj.price}}</span>
                    <span>起</span>
                </div>
            </div>
        </div>
        <div class="skeleton-box" v-if="!hotelObj.chinese_name">
            <div class="left-box">
                <Skeleton width="100px" height="165px" radius="10px"></Skeleton>
            </div>
            <div class="right-box">
                <Skeleton width="210px" height="22px"></Skeleton>
                <Skeleton width="56px" height="17px"></Skeleton>
                <div class="inline-one">
                    <Skeleton width="28px" height="29px"></Skeleton>
                    <Skeleton width="92px" height="17px"></Skeleton>
                </div>
                <Skeleton width="152px" height="17px"></Skeleton>
                <div class="inline">
                    <Skeleton width="50px" height="17px"></Skeleton>
                    <Skeleton width="50px" height="17px"></Skeleton>
                    <Skeleton width="50px" height="17px"></Skeleton>
                    <Skeleton width="50px" height="17px"></Skeleton>
                </div>
                <div class="last">
                    <Skeleton width="50px" height="30px" backgroundColor="#ffc3be"></Skeleton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Skeleton from '@/pages/hotel/components/skeleton'
import commonfunction from '@/pages/hotel/api/publiccommon'
export default {
    components:{
        Skeleton
    },
    props:{
        setData:{//传入的具体数据
            type:Object,
            required:true,
        }
    },
    data() {
        return {
            hotelObj:{},//酒店对象
            loading: true,//骨架屏加载
        };
    },
    created(){
        this.hotelObj = this.setData
    },
    methods: {
        toggle() {//外部点击事件
            if(this.hotelObj&&this.hotelObj.hotel_id){
                this.$emit('toggle',this.hotelObj.hotel_id)
            }
        },
        showTag(str) {//小标签
            let arr = str.split(',');
            return arr
        },
        //处理距离显示
        unitConvert(num){
        return commonfunction.unitConvert(num)
        },
    },
    watch:{
        setData(){
            this.hotelObj = this.setData
        }
    },
};
</script>

<style lang="less" scoped>
.hotel-product {
    width: 100%;
    padding: 1.5rem 1.5rem 0 1.5rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .img-box {
        width: 10rem;
        // height: 100%;
        border-radius: 1rem;
        margin-right: 1rem;
        overflow: hidden;
        img {
            display: inline-block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .content {
        flex: 1;
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 0.1rem;
            background-color: #dddddd;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
        }
        h3 {
            margin: 0;
            font-size: 1.6rem;
            line-height: 2.2rem;
            color: #333;
            font-weight: 500;
            vertical-align: top;
            span {
                display: inline-block;
                font-size: 1.2rem;
                color: #666;
                line-height: 1.7rem;
                font-weight: 400;
            }
        }
        .nums {
            span {
                display: inline-block;
                vertical-align: middle;
                &:nth-of-type(1) {
                    font-size: 2rem;
                    font-weight: 600;
                    line-height: 2.9rem;
                    color: #108b30;
                    margin-right: 1.1rem;
                }
                &:nth-of-type(2) {
                    font-size: 1.3rem;
                    font-weight: 500;
                    line-height: 2.7rem;
                    color: #F49103;
                }
                &:nth-of-type(3) {
                    font-size: 1.3rem;
                    font-weight: 400;
                    line-height: 1.8rem;
                    color: #999999;
                }
            }
        }
        p {
            font-size: 1.2rem;
            font-weight: 400;
            line-height: 1.7rem;
            color: #666666;
            margin: 0.3rem 0 0.5rem 0;
            vertical-align: top;
            >span{
                display: inline-block;
                max-width: 16rem;
                line-height: 1.7rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                vertical-align: top;
                margin-left: 0.5rem;
            }
        }
        .tags {
            line-height: 1.7rem;
            height: 1.7rem;
            overflow: hidden;
            span {
                display: inline-block;
                font-size: 1rem;
                height: 1.7rem;
                line-height: 1.7rem;
                padding: 0 0.2rem;
                margin-bottom: 0.2rem;
                box-sizing: border-box;
                position: relative;
                white-space: nowrap;
                background-color: #fff;
                &::after {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 200%;
                    height: 200%;
                    border-radius: 0.6rem;
                    -webkit-transform-origin: 0 0;
                    -moz-transform-origin: 0 0;
                    -ms-transform-origin: 0 0;
                    -o-transform-origin: 0 0;
                    transform-origin: 0 0;
                    -webkit-transform: scale(0.5, 0.5);
                    -ms-transform: scale(0.5, 0.5);
                    -o-transform: scale(0.5, 0.5);
                    transform: scale(0.5, 0.5);
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                }
                &:not(:last-child) {
                    margin-right: 0.5rem;
                }
                &.tag1 {
                    color: #108b30;
                    &::after {
                        border: 0.1rem solid #108b30;
                    }
                }
                &.tag2 {
                    color: #f49103;
                    &::after {
                        border: 0.1rem solid #f49103;
                    }
                }
                &.tag3 {
                    color: #ff6253;
                    &::after {
                        border: 0.1rem solid #ff6253;
                    }
                }
                &.tag4 {
                    color: #00a9ff;
                    &::after {
                        border: 0.1rem solid #00a9ff;
                    }
                }
            }
        }
        .price {
            display: flex;
            justify-content: flex-end;
            margin: 1rem 0;
            > div {
                span {
                    display: inline-block;
                    &:nth-of-type(1) {
                        font-size: 1.2rem;
                        font-weight: 400;
                        color: #f84737;
                    }
                    &:nth-of-type(2) {
                        font-size: 2.2rem;
                        font-weight: 600;
                        line-height: 3rem;
                        color: #f84737;
                    }
                    &:nth-of-type(3) {
                        height: 100%;
                        font-size: 1.2rem;
                        font-weight: 400;
                        color: #999999;
                        margin-left: 0.5rem;
                        vertical-align: bottom;
                        line-height: 3rem;
                    }
                }
            }
        }
    }
    .skeleton-box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .left-box {
            padding-right: 1rem;
            box-sizing: border-box;
        }
        .right-box {
            flex: 1;
            .inline{
                >div{
                    margin-right: 0.5rem;
                }
            }
            .inline-one{
                >div{
                    margin-right: 1rem;
                }
            }
            > div {
                margin-bottom: 0.5rem;
            }
            .inline,
            .inline-one {
                display: flex;
                align-items: center;
            }
            .last{
                display: flex;
                justify-content: flex-end;
                margin: 0;
                margin-top: 1.3rem;
            }
        }
    }
}
.text-overflow-line2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
}
</style>